<template>
    <div class="request-store__footer">
        <!-- Слот, чтобы футер годился не только заявкам: списку оборудования нужен
             диапазон «Показано A–B из N», а не счётчик со склонением. -->
        <span class="request-store__count">
            <slot name="summary">{{ total }} {{ requestsWord }} · страница {{ value }} из {{ totalPages }}</slot>
        </span>
        <div class="request-store__footer-right">
            <label class="request-store__per-page">
                Строк:
                <select :value="perPage" @change="$emit('per-page', Number($event.target.value))">
                    <option v-for="option in perPageSelectOptions" :key="option" :value="option">
                        {{ option }}
                    </option>
                </select>
            </label>
            <PagePaginate
                :count="perPage"
                :total="total"
                :value="value"
                @change="$emit('input', $event)"
            ></PagePaginate>
        </div>
    </div>
</template>
<script>
import PagePaginate from '@/views/components/PagePaginate';
import { pluralizeRu, perPageOptions } from '@/js/requestStorePagination';

// Футер вынесен из RequestStorePagination, чтобы жить вне области прокрутки списка:
// внутри неё счётчик и пейджер уезжали вместе с таблицей при горизонтальной прокрутке.
export default {
    components: { PagePaginate },
    props: {
        total: { type: Number, required: true },
        totalPages: { type: Number, default: 1 },
        perPage: { type: Number, required: true },
        value: { type: Number, default: 1 },
    },
    computed: {
        requestsWord() {
            return pluralizeRu(this.total, 'обращение', 'обращения', 'обращений');
        },
        perPageSelectOptions() {
            return perPageOptions(this.perPage);
        },
    },
};
</script>
<style lang="scss">
.request-store {
    &__footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 12px;
        // Нижние 12px вместо прежних 4px: футер больше не висит в конце прокрутки,
        // где воздух давал padding-bottom самой области, а стоит у края панели.
        padding: 12px 15px;
        // Футер стоит под областью прокрутки и не должен сжиматься, когда список длинный.
        flex-shrink: 0;
        // Строки уезжают под футер — без линии список выглядит обрезанным на полуслове.
        border-top: 1px solid #f1f3f4;
        background: #fff;
    }

    &__count {
        font: 400 0.8125rem var(--font-family);
        color: #5f6368;
        white-space: nowrap;
    }

    &__footer-right {
        display: flex;
        align-items: center;
        gap: 14px;

        .pagination {
            width: auto;
        }
    }

    &__per-page {
        display: flex;
        align-items: center;
        gap: 8px;
        font: 400 0.8125rem var(--font-family);
        color: #5f6368;
        white-space: nowrap;

        select {
            height: 30px;
            padding: 0 8px;
            border: 1px solid #e3e5e8;
            border-radius: 9px;
            background: #fff;
            color: #3c4043;
            font: 500 0.8125rem var(--font-family);
            cursor: pointer;

            &:hover {
                border-color: #d4d7db;
            }
        }
    }
}
</style>
